import {
	EVENT_LOAD_OPTIONS,
	EVENT_NEW_REPORTING_ENTITY,
	EVENT_NEW_FORM,
	EVENT_REQUEST_REPORTING_ENTITY,
	EVENT_RESET_REPORTING_ENTITY
} from "constants.js";
import { orderBy } from "lodash";
import template from "./reporting-entity-selector.html";
import "./reporting-entity-selector.less";
import moment from "moment";
import { effectiveRangeStatus } from "../../utils/effectiveRanges/effectiveRangeStatus";
import { uuid } from "../../utils";

// reportingEntitySelector
export function controller(
	$scope,
	appState,
	eventBus,
	entityManager,
	$logger
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.handleValueChange = handleValueChange;
	ctrl.clearSelected = clearSelected;
	ctrl.switchPrimary = switchPrimary;
	ctrl.selected = { primary: {}, friendly: {} };
	ctrl.selectId = `reporting-entity-selector:${uuid()}:select`;
	ctrl.shouldRequestPrimaryUpdate = !!this.shouldRequestPrimaryUpdate;

	function onInit() {
		ctrl.form = appState.forms.selected;

		const selector = {
			clearSelected: () => clearSelected(),
			enable: () => ctrl.selectBox.enable()
		};

		this.callbacks({ selector });

		eventBus.register(
			EVENT_NEW_FORM,
			() => {
				ctrl.form = appState.forms.selected;
				appState.clearSelectedEntity();
				getAssociatedEntities();
			},
			$scope
		);

		eventBus.register(EVENT_REQUEST_REPORTING_ENTITY, (_, { friendly }) => handleValueChange({ friendly }), $scope);

		eventBus.register(
			EVENT_RESET_REPORTING_ENTITY,
			() => {
				resetDefault();
			},
			$scope
		);

		if(ctrl.fieldIdentifier !== undefined) {
			eventBus.register(
				EVENT_LOAD_OPTIONS(ctrl.fieldIdentifier),
				(_, params) => {
					getAssociatedEntities(params.entities);
				},
				$scope
			);
		}

		getAssociatedEntities();
	}

	ctrl.setSelectBox = function(selectBox) {
		ctrl.selectBox = selectBox;

		if(ctrl.selected.primary.Id || ctrl.selected.friendly.isSelf || entityManager.isAllPrimaries()) {
			ctrl.selectBox.setValue(ctrl.selected.primary, ctrl.selected.friendly, false);
		}
	};

	function clearSelected() {
		appState.clearSelectedEntity();
		ctrl.selectBox.clearSelected();
	}

	async function getAssociatedEntities(entities) {
		if(entities !== undefined) {
			ctrl.associatedEntities = entities;
			ctrl.selectBox.setChoices(entities);
		}

		if(ctrl.associatedEntities === undefined) {
			ctrl.associatedEntities = entityManager.getPrimaryFieldEntities();

			if(ctrl.default === true) {
				setDefault();
				eventBus.trigger(EVENT_NEW_REPORTING_ENTITY);
			}
		}

		if(ctrl.entityQueryConfiguration === undefined) {
			ctrl.entityQueryConfiguration = entityManager.primaryEntityQueryConfiguration;
		}

		ctrl.field = entityManager.displayMetadata;
	}

	function resetDefault() {
		setDefault(false);
	}

	function setDefault(keepSelected) {
		let selected = keepSelected === false ? null : entityManager.getSelectedEntity();
		const now = moment();
		const effectiveAsOf = { fromInclusive: now, toExclusive: now, allowPartial: true };

		//CLEANUP (JTS): It appears that allFriendlies is misused here
		//It is assigned an orderBy, but accessed via ctrl.allFriendlies after the scoped block
		//Also, it appears the elements of the control are already ordered, so another may be unnecessary
		let allFriendlies = [];

		//if not set, set to first friendly & primary
		if((!selected || !((!!selected.primary && !!selected.primary.Id) || (!!selected.friendly && !!selected.friendly.Id))) && ctrl.associatedEntities.length) {
			allFriendlies = orderBy(ctrl.associatedEntities, [(entity) => entity.Name], "asc");

			//find first friendly that's in-season
			for(let i = 0; i < ctrl.associatedEntities.length; i++) {
				const thisFriendly = allFriendlies[i];

				if(!!thisFriendly.Entities && thisFriendly.Entities.length > 0) {
					for(let j = 0; j < thisFriendly.Entities.length; j++) {
						const thisPrimary = thisFriendly.Entities[j].Entity;
						const status = effectiveRangeStatus(thisPrimary, effectiveAsOf);

						if(status.isEither) {
							selected = {
								friendly: thisFriendly,
								primary: thisPrimary
							};
							break;
						}
					}
				}
				else {
					const status = effectiveRangeStatus(thisFriendly, effectiveAsOf);

					if(!thisFriendly.Effective || status.isEither) {
						selected = {
							friendly: thisFriendly,
							primary: {}
						};
						break;
					}
				}
			}
		}

		if(!selected || !selected?.friendly && !selected?.primary) {
			selected = {
				primary: {},
				friendly: allFriendlies[0]
			};
		}

		entityManager.selectEntity(selected.friendly.Id);
		ctrl.selected = selected;
		setPrimarySwitcherButton(selected.friendly);
	}

	function handleValueChange(item) {
		if(item) {
			setPrimarySwitcherButton(item.friendly);
			ctrl.selected = item;
		}
		entityManager.selectEntity(item && (item.Id || item.friendly.Id));

		eventBus.trigger(EVENT_NEW_REPORTING_ENTITY);

		if(ctrl.onChanged) {
			ctrl.onChanged(item);
		}
	}

	function setPrimarySwitcherButton(friendly) {
		ctrl.showPrimarySwitcher = !ctrl.shouldRequestPrimaryUpdate && friendly && friendly.Entities && friendly.Entities.length > 1;
	}

	function switchPrimary() {
		this.selectBox.switchPrimary();
	}
}
export default angular
	.module("vesl.components.reporting-entity-selector", [])
	.component("reportingEntitySelector", {
		template,
		controller,
		bindings: {
			onChanged: "=",
			default: "<",
			isReadonly: "<",
			callbacks: "&",
			shouldRequestPrimaryUpdate: "<",
			associatedEntities: "<",
			entityQueryConfiguration: "<",
			fieldLabel: "<",
			fieldIdentifier: "<"
		}
	}).name;
